/*
 * Publishes a sticky `top` per PDP column so whichever column is shorter ends up
 * pinned: a column that fits below the header pins under it, a column taller
 * than the viewport pins once its bottom reaches the viewport bottom.
 *
 * The value is written as a custom property rather than as `position`/`top`
 * directly so the CSS default (`top: auto`) is a sticky box that never pins —
 * a blocked script leaves both columns static. That drops the info column's
 * old fixed 3rem pin too, by design: no JS means no pinning at all.
 */
if (!customElements.get('product-column-sticky')) {
  class ProductColumnSticky extends HTMLElement {
    connectedCallback() {
      // The quick-add modal clones this section's markup into its own scroll
      // container (`.quick-add-modal__content`), so the header/viewport-relative
      // offset this element publishes on the page is meaningless there. Leaving
      // `--column-sticky-top` unset keeps the CSS default (`top: auto`), which
      // never pins.
      if (this.closest('quick-add-modal')) return;

      this.columns = Array.from(this.querySelectorAll('.product__media-gallery, .product__info-container--sticky'));
      if (this.columns.length === 0) return;

      this.header = document.querySelector('sticky-header.header-wrapper');
      this.onResize = this.schedule.bind(this);
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.columns.forEach((column) => this.resizeObserver.observe(column));
      if (this.header) this.resizeObserver.observe(this.header);
      window.addEventListener('resize', this.onResize);

      this.publish();
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    schedule() {
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.publish();
      });
    }

    publish() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const viewportHeight = window.innerHeight;

      this.columns.forEach((column) => {
        const height = column.offsetHeight;
        const top = height <= viewportHeight - headerHeight ? headerHeight : viewportHeight - height;
        column.style.setProperty('--column-sticky-top', `${Math.round(top)}px`);
      });
    }
  }

  customElements.define('product-column-sticky', ProductColumnSticky);
}
